// Force config to initialize first (avoid TDZ in production bundle)
import './config/environment'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/abacus-sw.js').catch((error) => {
      console.warn('Service worker registration failed:', error);
    });
  });
}
